import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HUBSPOT_MEETINGS } from 'recording-review-components-lib/types/CallSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranscriptionStatusGenericEmptyState = props => {
  const {
    hasRecording,
    callSource
  } = props;
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "calling-transcript-empty-state",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.title"
    }),
    children: !hasRecording && /*#__PURE__*/_jsx("p", {
      children: callSource === HUBSPOT_MEETINGS ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notRecorded.notYetAvailableDescription"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notRecorded.description"
      })
    })
  });
};